var map = {
	"./back.svg": 55,
	"./badge-check.svg": 56,
	"./delete.png": 57,
	"./delete.svg": 58,
	"./google.svg": 59,
	"./hearth.svg": 60,
	"./like.svg": 61,
	"./logo.svg": 62,
	"./logo_small.svg": 63,
	"./nlike.svg": 64,
	"./title.svg": 65,
	"./trash.svg": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;